
import { Component, Prop, Vue } from 'vue-property-decorator'
import { CompareSide } from '@/api/placesCompare'

@Component({ name: 'ProviderColumn' })
export default class extends Vue {
  @Prop({ required: true }) private title!: string
  @Prop({ default: '' }) private tone!: string
  @Prop({ default: null }) private side!: CompareSide | null
  // Normalised names the other provider returned, so a venue only this side
  // found can be marked in place rather than counted at the top.
  @Prop({ default: () => [] }) private otherNames!: string[]

  private isUnique(name: string) {
    const n = String(name || '').toLowerCase().replace(/[^a-z0-9çğıöşü]/gi, '')
    return !!n && this.otherNames.indexOf(n) === -1
  }
}
